import useUserService from 'hooks/user-service'
import useBlock from 'hooks/block'
import stylistNormalizer from './formatter/profile'
import reviewsFormatter from './formatter/reviews'

export default function useStoreState(initData) {
  const userInit = user => {
    stylistNormalizer(user)
    return user
  }

  const reviewInit = reviews => reviewsFormatter(reviews)

  const { state, mutate } = useStatic({ refreshSchedule: 0 })

  const initState = () => {
    const { user, posts, reviews, breadcrumbs } = initData
    if (state.profile?.id === user.id) return
    state.profile = userInit(user)
    state.posts = posts
    state.breadcrumbs = breadcrumbs
    state.reviews = reviewInit(reviews)
  }
  initState()

  const { user } = useCurrent()
  const panel = usePanel()
  const router = useRouter()
  const [userId] = router.query.params
  const { model } = router.query
  const { services } = useUserService({ userId, force: true })
  const { blockActionWrapper } = useBlock(userId)

  const checkLogin = () => {
    if (user) return true
    panel.open('auth')
    return false
  }

  const openBuyDeposit = () => {
    if (!checkLogin()) return
    h.openBuyDeposit({
      stylistId: state.profile.stylist.id,
      stylistUserId: state.profile.id,
      stylistName: state.profile.name
    })
  }

  const callback = () => {
    state.refreshSchedule += 1
    mutate()
  }

  const openPrepayBooking = () => {
    blockActionWrapper(
      () => $openPrepayBooking({
        stylistId: state.profile.stylist.id,
        stylistUserId: state.profile.id,
        stylistName: state.profile.name,
        isModel: model,
        callback
      })
    )
  }

  const openReview = () => h.reviewOpen({
    type: 'stylist',
    id: state.profile.id
  })

  return {
    state,
    mutate,
    services,
    openBuyDeposit,
    openReview,
    openPrepayBooking
  }
}
